// @generated by scripts/gen-modules.mjs
import { RouteObject, Navigate } from 'react-router-dom';
import { TicketsRoutes } from './modules/tickets';
import { AdvancedTicketsRoutes } from './modules/advanced-tickets';
import { KnowledgeRoutes } from './modules/knowledge';
import { SelfserviceRoutes } from './modules/selfservice';
import { CommunicationRoutes } from './modules/communication';
import { AnalyticsRoutes } from './modules/analytics';
import { FeedbackRoutes } from './modules/feedback';
import { ProactiveRoutes } from './modules/proactive';

export const supportRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="tickets/tickets" replace /> },
  TicketsRoutes,
  AdvancedTicketsRoutes,
  KnowledgeRoutes,
  SelfserviceRoutes,
  CommunicationRoutes,
  AnalyticsRoutes,
  FeedbackRoutes,
  ProactiveRoutes,
];

export default supportRoutes;
